<template>
    <div>
        <loader v-if="loading"/>
        <div v-show="!loading">
            <div class="alert alert-danger" role="warning" v-if="paymentReceiptNotFound">
                <strong>Payment Receipt Not Found</strong>
            </div>
            <div id="paymentAlert" class="alert alert-success" role="warning" v-if='!paymentReceiptNotFound'>
                <strong>Payment Has Been Processed</strong>
            </div>
            <div class="form-group">
                <label class="col-md-3 control-label">Transaction ID</label>
                <div class="col-md-8">
                        <span class="textValue">{{transactionReceipt.transactionId}}</span>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-3 control-label">Transaction Date</label>
                <div class="col-md-8">
                        <span class="textValue">{{transactionReceipt.transactionDate}}</span>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-3 control-label">Card Type</label>
                <div class="col-md-8">
                        <span class="textValue">{{transactionReceipt.cardType}}</span>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-3 control-label">Card Number (last 4 digits)</label>
                <div class="col-md-8">
                        <span class="textValue">{{transactionReceipt.cardNumber}}</span>
                </div>
            </div>
            <!-- <div class="form-group">
                <label class="col-md-3 control-label">Card Holder Name</label>
                <div class="col-md-8">
                        <span class="textValue">{{transactionReceipt.cardHolderName}}</span>
                </div>
            </div> -->
            <div class="form-group">
                <label class="col-md-3 control-label">Amount</label>
                <div class="col-md-8">
                        <span class="textValue">{{transactionReceipt.amount}}</span>
                </div>
            </div>
            <div class="form-group" >
                <label class="col-md-3 control-label">Note</label>
                <div class="col-md-8">
                        <span class="textValue">{{transactionReceipt.note}}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-3" v-if="!paymentReceiptNotFound">
                    <button name="receiptReport" class="btn btn-primary" v-on:click="genReceiptReport">Print Receipt</button>
                </div>  
                <div class="col-md-3">
                    <button name="button2" class="btn btn-primary btn-block" type="submit" v-on:click="goFileSearch">Return to File Search</button>
                </div>
            </div>
        </div>
        <div v-show="isDebug">
            <div>
                <h3 class="text-danger">****** Debug ******</h3>
            </div>
            <div>
                <h4>transactionReceipt: </h4>
                <pre>{{ transactionReceipt }}</pre>
            </div>
        </div>
    </div>
</template>


<script>

import loader from '../components/Loader.vue'
import loggingService from '../services/util/loggingService'
import paymentService from '../services//paymentService'
import mediaService from '../services/mediaService'

export default {
    components: {
        loader
    },
    mounted () {
        this.fileSearchId = this.$route.params.fileSearchId
        if (!this.fileSearchId) {
            //get square transaction id from url
            var transactionId = this.$route.query.transactionId
            var checkoutId = this.$route.query.checkoutId
            paymentService.completeSquareTransaction(this.$http, paymentService.PaymentTypeEnum.FileSearch, transactionId, checkoutId).then(response => {
                //console.log(response.data)
                if (response.data.isValid && response.data.objectList.length > 0) {
                    this.transactionReceipt = response.data.objectList[0]
                    this.$router.push('/FileSearchPaymentReceipt/' + response.data.objectList[0].parentId)
                    this.loading = false
                }
            })
        //     loggingService.log(this.isDebug, 'File Search Payment receipt', 'mounted')
        //     this.transactionReceipt.CVV2Response = this.$route.query.ssl_cvv2_response
        //     this.transactionReceipt.LastName = this.$route.query.ssl_last_name
        //     this.transactionReceipt.Zip = this.$route.query.ssl_avs_zip
        //     this.transactionReceipt.ProductDescription = this.$route.query.ProductDescription
        //     this.transactionReceipt.ExpireDate = this.$route.query.ssl_exp_date
        //     this.transactionReceipt.AccountBalance = this.$route.query.ssl_account_balance
        //     this.transactionReceipt.Token = this.$route.query.ssl_token
        //     this.transactionReceipt.GetToken = this.$route.query.ssl_get_token
        //     this.transactionReceipt.Message = this.$route.query.ssl_result_message
        //     this.transactionReceipt.TokenResponse = this.$route.query.ssl_token_response
        //     this.transactionReceipt.Country = this.$route.query.ssl_country
        //     this.transactionReceipt.City = this.$route.query.ssl_city
        //     this.transactionReceipt.Address1 = this.$route.query.ssl_avs_address
        //     this.transactionReceipt.Address2 = this.$route.query.ssl_address2
        //     this.transactionReceipt.FirstName = this.$route.query.ssl_first_name
        //     this.transactionReceipt.State = this.$route.query.ssl_state
        //     this.transactionReceipt.Amount = this.$route.query.ssl_amount
        //     this.transactionReceipt.TransactionID = this.$route.query.ssl_txn_id
        //     this.transactionReceipt.Result = this.$route.query.ssl_result
        //     this.transactionReceipt.CardNumber = this.$route.query.ssl_card_number
        //     this.transactionReceipt.CardType = this.$route.query.CardType
        //     this.transactionReceipt.TransactionDate = this.$route.query.ssl_txn_time
        //     this.transactionReceipt.ProductDescription = this.$route.query.ProductDescription

        //     var start = this.transactionReceipt.ProductDescription.indexOf('FS: ') + 4
        //     var end = this.transactionReceipt.ProductDescription.length
        //     this.transactionReceipt.parentId = this.transactionReceipt.ProductDescription.substr(start, end)
        //     loggingService.log(this.isDebug, 'File Search Payment receipt', 'FileSearchId = *' + this.transactionReceipt.parentId + '*')
        //     paymentService.saveTransactionReceipt(this.$http, this.transactionReceipt)

        //     this.loading = false
        } else {
            var handle = this
            handle.loadPaymentReceipt(handle.fileSearchId).then(function () {
                handle.loading = false
            })
        }
    },
    data: function () {
        return {
            isDebug: false,
            loading: true,
            fileSearchId: -1,
            transactionReceipt: {},
            paymentReceiptNotFound: false
        }
    },
    methods: {
        goFileSearch () {
            this.$router.push('/FileSearch/' + this.transactionReceipt.parentId)
        },
        loadPaymentReceipt (fileSearchId) {
            loggingService.log(this.isDebug, 'FileSearch', 'loadPaymentReceipt - start - fileSearchId:' + fileSearchId)
            var handle = this
            return paymentService.getTransactionReceipt(this.$http, paymentService.PaymentTypeEnum.FileSearch, fileSearchId).then(function (response) {
                if (response.data) {
                    handle.transactionReceipt = response.data
                } else {
                    loggingService.log(handle.isDebug, 'GetTransactionReceipt', 'Error: cannot find data')
                    handle.transactionReceipt.parentId = handle.fileSearchId
                    handle.paymentReceiptNotFound = true
                }
            })
        },
        genReceiptReport () {
            if (this.fileSearchId || this.transactionReceipt.parentId) {
                var fileSearchId = this.fileSerachId || this.transactionReceipt.parentId
                paymentService.paymentReceiptReportGen(this.$http, paymentService.PaymentTypeEnum.FileSearch, fileSearchId).then(response => {
                    mediaService.saveFileToDownload(response, 'PaymentReceipt.pdf')
                })
            }
        }
    }
}

</script>



// WEBPACK FOOTER //
// FileSearchPaymentReceipt.vue?0273490f